import { Injectable } from '@angular/core';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

@Injectable()
export class P600CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.P600];

	public override showPatentInfo(): boolean {
		return false;
	}

	public enableStereoAudio(_model: DeviceModel, _numberOfChannels: number): boolean {
		return true;
	}

	// TODO - This is a temporary workaround for beta, and should be removed when stereo audio is supported in the P600.
	// Related ticket: https://shure.atlassian.net/browse/DNG-34389
	public showStereoAudioToggle(_model: DeviceModel): boolean {
		return false;
	}

	public showUSBStereoAudioMessage(_model: DeviceModel): boolean {
		return true;
	}
}
